/*
    env配置以及http拦截
*/

import Vue from "vue";
import axios from "axios";
import { Message } from "element-ui";
import getJwtSafeCode from "./jwt.js";
import Common from "../common/common";
import router from "../../router/routers";
const baseAPIUrl = process.env.API_ENV; // Base API：serve、testing10、testing20、pre、prod
const configServer = {
    API_URL: "", // API Base URL
    KF_URL: ""
};
switch (baseAPIUrl) {
    case "serve": // dev
        configServer.API_URL = "/api/";
        configServer.KF_URL = "//gc20.51gofunev.com/backend/customer/";
        configServer.GC_URL = "//gc20.51gofunev.com/view/";
        configServer.KF_WS = "customersocket20.51gofunev.com/";
        configServer.ENTERPRISE = "https://test-enterprise.shouqiev.com/";
        configServer.CONNPORTAL_URL = "https://test-connportalapi.shouqiev.com/api/";
        break;
    case "testing10": // testing10
        configServer.API_URL = "//test-gc.shouqiev.com/api/";
        configServer.KF_URL = "//test-gc.shouqiev.com/backend/customer/";
        configServer.GC_URL = "//test-gc.shouqiev.com/view/";
        configServer.KF_WS = "test-customersocket.shouqiev.com/";
        configServer.ENTERPRISE = "//test-enterprise.shouqiev.com/";
        configServer.CONNPORTAL_URL = "https://test-connportalapi.shouqiev.com/api/";
        break;
    case "testing20": // testing20
        configServer.API_BI = "//gc20.shouqiev.com/api/reportform";
        configServer.API_URL = "//gc20.51gofunev.com/api/";
        configServer.KF_URL = "//gc20.51gofunev.com/backend/customer/";
        configServer.GC_URL = "//gc20.51gofunev.com/view/";
        configServer.KF_WS = "customersocket20.51gofunev.com/";
        configServer.ENTERPRISE = "//enterprise20.51gofunev.com/";
        break;
    case "pre": // pre
        configServer.API_BI = "//pre-gc.shouqiev.com/api/reportform";
        configServer.API_URL = "//pre-gc.shouqiev.com/api/";
        configServer.KF_URL = "//pre-gc.shouqiev.com/backend/customer/";
        configServer.GC_URL = "//pre-gc.shouqiev.com/view/";
        configServer.KF_WS = "pre-gc.shouqiev.com/backend/customersocket/";
        configServer.ENTERPRISE = "https://pre-enterprise.shouqiev.com/";
        configServer.CONNPORTAL_URL = "https://pre-connportalapi.shouqiev.com/api/";
        break;
    case "production": // prod
        configServer.API_BI = "//gc.shouqiev.com/api/reportform";
        configServer.API_URL = "//gc.shouqiev.com/api/";
        configServer.KF_URL = "//gc.shouqiev.com/backend/customer/";
        configServer.GC_URL = "//gc.shouqiev.com/view/";
        configServer.KF_WS = "gc.shouqiev.com/backend/customersocket/";
        configServer.ENTERPRISE = "//gc.shouqiev.com/backend/enterprise/";
        configServer.CONNPORTAL_URL = "https://connportalapi.shouqiev.com/api/";
        break;
    default:
        // prod
        configServer.API_BI = "//gc.shouqiev.com/api/reportform";
        configServer.API_URL = "";
        configServer.KF_URL = "api/";
        configServer.GC_URL = "//gc.shouqiev.com/";
        configServer.KF_WS = "customersocket.shouqiev.com/";
        configServer.ENTERPRISE = "https://gc.shouqiev.com/backend/enterprise/";
        configServer.CONNPORTAL_URL = "https://connportalapi.shouqiev.com/api/";
        break;
}
// axios.defaults.withCredentials = true;
// axios.defaults.baseURL = configServer.API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

axios.interceptors.request.use(
    configData => {
        let jwt = getJwtSafeCode();
        let token = Common.getCookie("token") || Common.getParamsFromURL(location.href, 'token');
        configData.headers.Authorization = jwt;
        configData.headers["X-API-Token"] = token;
        configData.headers["token"] = token;
        return configData;
    },
    errorny => {
        return Promise.reject(errorny);
    }
);
axios.interceptors.response.use(
    response => {
        // 文件流下载
        if (response.config.exportFlag) {
            return response;
        }
        if (response.data.code != "200" && response.data.code != "401") {
            if (response.data.message) {
                Common.message({
                    message: response.data.message,
                    type: "error",
                    duration: 1500
                });
              if (response.data.code == "110" || response.data.code == "111" || response.data.code == "108" || response.data.code == "109"){
                setTimeout(() => {
                  router.replace({path: '/findPass',params: {title: '修改密码'}})
                },1000)
              }
            } else {
                Common.message({
                    message: "系统异常",
                    type: "error",
                    duration: 1500
                });
            }
            // 登录接口返回错误
            if (response.config.url.includes("/login")) {
                return response.data;
            }
        } else if (
            response.data.code == "401" &&
            process.env.API_ENV !== "serve"
        ) {
          console.log('🐅')
            router.replace({
                path: "/login"
            });
        } else {
            return response.data;
        }
    },
    error => {
        if (error.response.status === 401) {
          if(location.href.indexOf('noLogin')>-1){
            console.log('通过url发现不处理401未登录')
          } else {
            console.log(location.href)
            console.log('🍌🍌')
              Common.message({
                  message: "登录失效,请重新登录",
                  type: "error",
                  duration: 1500
              });
              router.replace({
                  path: "/login"
              });
          }
        }
        return Promise.reject(error.response);
    }
);

export default configServer;



// WEBPACK FOOTER //
// ./src/utils/config-server/config-server.js